import { Route, Switch as RRDSwitch } from 'react-router-dom';

import Objects from './features/Objects';
import Routes from './features/Routes';
import Statistics from './features/Statistics';
import Discounts from './features/Discounts';
import Prizes from './features/Prizes';

const Switch = () => {
  return (
    <RRDSwitch>
      <Route path="/statistics">
        <Statistics />
      </Route>
      <Route path="/objects">
        <Objects />
      </Route>
      <Route path="/objects-suggested">
        <Objects />
      </Route>
      <Route path="/routes">
        <Routes />
      </Route>
      <Route path="/discounts">
        <Discounts />
      </Route>
      <Route path="/prizes">
        <Prizes />
      </Route>
      <Route path="">Sveiki</Route>
    </RRDSwitch>
  );
};

export default Switch;
